let mainPath = "/dispatch";
let viewFolder = "Dispatch";

module.exports = [
    {
        path: mainPath,
        name: 'dispatches',
        component: () => import('../views/'+viewFolder+'/Index.vue'),
    }
]